import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useState } from "react";
import { PrimaryMobile } from "../../../buttons/mobile/Primary";
import { useNavigate } from "react-router-dom";

export function ManualSign({
  isOpen,
  setOpen,
  openLoader,
  setOpenLoader,
  handleRequestPhysicalSignature,
}) {
  const navigate = useNavigate();
  const [selectedReward, setSelectedReward] = useState({});

  const handleSelectReward = (index, reward) => {
    let newReward = { ...reward, index };
    setSelectedReward(newReward);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedReward({});
  };

  const handleConfirm = () => {
    return navigate(selectedReward?.href ?? "#");
  };

  const requests = [
    { id: 1, description: "Fotocopia cédula de ciudadanía." },
    { id: 2, description: "Certificado laboral no mayor a 30 días." },
    { id: 3, description: "Últimos 3 desprendibles de pago de nómina." },
    {
      id: 4,
      description: "Certificado de cuenta bancaria no mayor a 30 días.",
    },
    {
      id: 5,
      description:
        "Contrato de crédito debidamente firmado, la firma la debe incorporar en todas las páginas del documento.",
    },
    {
      id: 6,
      description: "Pagaré y carta de instrucciones debidamente firmadas.",
    },
    {
      id: 7,
      description:
        "Documento de aceptación de los términos y condiciones generales del servicio debidamente firmado.",
    },
    {
      id: 8,
      description:
        "Documento de aceptación de la Política de Privacidad y Tratamiento de datos debidamente firmado y autenticado ante Notaría.",
    },
  ];

  return (
    <>

      <Dialog open={isOpen} onClose={handleClose} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-darkBgLight bg-opacity-75 transition-opacity duration-200 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed md:inset-y-0 bottom-0 md:right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform h-128 md:h-full transition duration-300 ease-in-out data-[closed]:translate-y-full"
              >
                <div className="flex h-full flex-col rounded-t-3xl md:rounded-none bg-darkBg tracking-tight font-walsheim">
                  <div className="">
                    <div className="py-6">
                      <div className="flex justify-between px-4 pt-2 md:pt-8">
                        <DialogTitle>
                          <div className="text-white">Firma en físico</div>
                        </DialogTitle>
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleClose}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                      <div className="hidden md:block px-4 pt-8 ">
                        <div className=" text-grayP text-sm">
                          Tu crédito queda en pendiente de Firma, para proceder
                          con el desembolso recuerda que debes firmar los
                          documentos de tu crédito. Una vez remitas todos los
                          documentos indicados en el presente documento, Galilea
                          se reserva el derecho a realizar la verificación de
                          estos, este procedimiento puede tardar entre 3 a 5
                          días hábiles con posterioridad a la remisión de los
                          documentos firmados de manera manuscrita.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-full rounded-t-3xl bg-white overflow-auto">
                    <div className="text-grayP pt-4 px-4">
                      Firma manuscrita - Proceso de firma física
                    </div>
                    <div className="pb-8 px-4 text-sm">
                      <div className="">
                        El Usuario de manera libre y voluntaria, de acuerdo con
                        su libertad de escogencia contractual puede firmar de
                        manera física los documentos del crédito. Razón por la
                        cual, Galilea, ha dispuesto para el titular que no desee
                        suscribir los documentos a través de la firma
                        electrónica, un canal adicional para realizar la firma
                        del crédito mediante el envío de la siguiente
                        documentación a la dirección de correspondencia física
                        Cl 79 No. 11 66 Ed Spaces, Bogotá, o a la dirección
                        electrónica de manera escaneada al correo electrónico
                        ayuda@galilea.co, si los documentos son enviados a la
                        dirección física o electrónica deben estar autenticados
                        por notaria. Los documentos que debe enviar el Usuario
                        son:
                      </div>
                    </div>
                    <div className="px-4 pl-8">
                      {requests.map((request, index) => (
                        <ul className="pb-4" key={'ul-' + index}>
                          <div className="text-sm" key={'div-' + index}>
                            <li className="list-disc font-bold" key={'li-' + index}>
                              {request.description}
                            </li>
                          </div>
                        </ul>
                      ))}
                    </div>
                    <div className="pb-8 px-4 text-sm">
                      <div className="">
                        El Usuario se obliga a suministrar información veraz,
                        completa, actualizada y comprobable, así mismo, este
                        deberá garantizar que a partir de los datos
                        suministrados no busca inducir al error en los procesos
                        internos, para lo cual, Galilea en procura de la
                        veracidad realizará las rectificaciones respectivas
                        siendo estas últimas de pleno conocimiento del Usuario.
                      </div>
                    </div>
                    <div className="pb-8 px-4 text-sm">
                      <div className="">
                        Haz clic en el botón "Iniciar proceso" para que a tu correo lleguen todos los documentos que debes firmar.
                      </div>
                    </div>
                    <div className="flex justify-center px-1 pb-4 w-full">
                      {
                        openLoader ? (
                          <>
                            <div className="p-2 ml-4 text-grayP" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                              <div>
                                <div className="loader-clousure-movements"> </div>
                              </div>
                              Enviando solicitud...
                            </div>
                          </>
                        ) :
                          (
                            <button
                              onClick={handleRequestPhysicalSignature}
                              type="button"
                              className={`flex justify-center p-2 rounded-full shadow-sm text-md font-semibold text-white bg-purple hover:bg-purpleDark transition duration-300  focus:outline-none`}
                            >
                              <div className="flex gap-2">
                                <div className="px-4">Iniciar proceso</div>
                              </div>
                            </button>
                          )
                      }
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
